import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { webhooksApi } from '@/lib/api/endpoints';

/** Dispara eventos no formato do Retell contra /api/webhooks/mock para testar o fluxo sem ligar. */
export function MockWebhookSimulator({ providerCallId }: { providerCallId: string }) {
  const qc = useQueryClient();
  const mut = useMutation({
    mutationFn: (payload: unknown) => webhooksApi.mock(payload),
    onSuccess: () => {
      toast.success('Evento enviado');
      void qc.invalidateQueries({ queryKey: ['calls'] });
      void qc.invalidateQueries({ queryKey: ['leads'] });
    },
    onError: () => toast.error('Falha ao enviar evento'),
  });
  const now = Date.now();
  const ended = (outcome: string, extra: Record<string, unknown> = {}) => ({
    event: 'call_analyzed',
    call: {
      call_id: providerCallId,
      call_status: 'ended',
      disconnection_reason: 'agent_hangup',
      start_timestamp: now - 75_000,
      end_timestamp: now,
      transcript: 'Agent: Oi! Aqui é a Ana da Fênix.\nUser: Oi, tudo bem.\nAgent: Vi que você deixou o produto no carrinho…',
      transcript_object: [
        { role: 'agent', content: 'Oi! Aqui é a Ana da Fênix. Vi que você começou a comprar e não finalizou. Posso ajudar?' },
        { role: 'user', content: 'Ah sim, eu tive um problema no pagamento.' },
        { role: 'agent', content: 'Sem problema! Tenho 15% de desconto se finalizar hoje. Posso te mandar o link por SMS?' },
        { role: 'user', content: outcome === 'recovered' ? 'Pode mandar sim!' : 'Não, obrigado.' },
      ],
      call_cost: { combined_cost: 8.4 },
      call_analysis: { call_summary: `Simulação: resultado ${outcome}.`, user_sentiment: outcome === 'recovered' ? 'Positive' : 'Neutral', custom_analysis_data: { outcome, wants_sms: outcome === 'recovered' } },
      ...extra,
    },
  });
  return (
    <div className="flex flex-wrap gap-2">
      <Button size="sm" variant="outline" onClick={() => mut.mutate({ event: 'call_started', call: { call_id: providerCallId, call_status: 'ongoing', start_timestamp: now } })}>Atendeu</Button>
      <Button size="sm" variant="outline" onClick={() => mut.mutate(ended('recovered'))}>Venda recuperada</Button>
      <Button size="sm" variant="outline" onClick={() => mut.mutate(ended('not_interested'))}>Sem interesse</Button>
      <Button size="sm" variant="outline" onClick={() => mut.mutate(ended('callback'))}>Pediu retorno</Button>
      <Button size="sm" variant="outline" onClick={() => mut.mutate({ event: 'call_ended', call: { call_id: providerCallId, call_status: 'ended', disconnection_reason: 'dial_no_answer', start_timestamp: now - 30_000, end_timestamp: now } })}>Não atendeu</Button>
      <Button size="sm" variant="outline" onClick={() => mut.mutate({ event: 'call_analyzed', call: { call_id: providerCallId, call_status: 'ended', disconnection_reason: 'voicemail_reached', call_analysis: { in_voicemail: true } } })}>Caixa postal</Button>
      <Button size="sm" variant="outline" className="text-destructive" onClick={() => mut.mutate(ended('do_not_call'))}>Não ligar mais</Button>
    </div>
  );
}
